export const MAX_WORD_LENGTH = 6
export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2000
export const WIN_ALERT_TIME_MS = 4000
export const REVEAL_TIME_MS = 350
